import App from 'App';
import env from 'config';
import { RADIX } from 'lib_ts/enums/radix-ui';
import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from 'reportWebVitals';
import { initSentry } from 'sentry';
import './index.scss';

initSentry();

const today = new Date();

if (!env.production && today.getMonth() === 3 && today.getDate() === 1) {
  RADIX.COLOR.ACCENT = 'brown';
  RADIX.COLOR.BETA = 'lime';
  RADIX.COLOR.WARNING = 'gray';
  RADIX.COLOR.DANGER = 'violet';
  RADIX.COLOR.SUCCESS = 'tomato';
  RADIX.COLOR.NEUTRAL = 'red';
  RADIX.COLOR.SECONDARY = 'yellow';
  RADIX.COLOR.FIRE_PITCH = 'gray';
  RADIX.COLOR.SEND_PITCH = 'plum';
  RADIX.COLOR.LEFT = 'amber';
  RADIX.COLOR.RIGHT = 'yellow';
}

const target = document.getElementById('app');
if (!target) {
  throw new Error('Root element #app not found');
}
const root = createRoot(target);

if (env.strict) {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  root.render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (env.enable.vitals) {
  reportWebVitals(console.debug);
}
